const DROPDOWN_NAMES = {
  auth: 'authorization_popup',
  adaptiveHeaderMenu: 'adaptive_header_menu',
  slider: 'slider_widget',
  search: 'search_widget',
  contentPage: 'content_page',
  problemSubscribe: 'problem_subscribe',
  mobilePlayer: 'mobile_player',
  channels: 'channels',
  subscriptionProblem: 'subscription_problem',
  subscribtionPopup: 'subscription_popup',
  editor: 'editor',
  notifications: 'notifications',
  signalForm: 'signal_form',
  signalLinks: 'signal_links',
  signalLinksFromPopup: 'signal_links_from_popup',
  briefcase: 'briefcase',
  ponPopup: 'pon_popup',
  telegramSubscribePopup: 'telegram_subscribe_popup',
};

export default DROPDOWN_NAMES;
